import React from 'react';

const Forms = (props) => {
    const { formCine, formKit, handleChange, prizeName } = props;
    return (
        <div className="forms-page">
            {prizeName === 'cine' && (
                <fieldset>
                    <label>Nombre</label>
                    <input type="text" data-action="formCine|nombre" onChange={handleChange} value={formCine.nombre} />
                    <label>Correo electrónico</label>
                    <input type="text" data-action="formCine|correo" onChange={handleChange} value={formCine.correo} />
                    <label>Celular</label>
                    <input type="text" data-action="formCine|telefono" onChange={handleChange} value={formCine.telefono} />
                </fieldset>
            )}
            
            {(prizeName === 'kit' || prizeName === 'book') && (
                <fieldset>
                    <label>Nombre</label>
                    <input type="text" data-action="formKit|nombre" onChange={handleChange} value={formKit.nombre} />
                    <label>Correo electrónico</label>
                    <input type="text" data-action="formKit|correo" onChange={handleChange} value={formKit.correo} />
                    <label>Celular</label>
                    <input type="text" data-action="formKit|celular" onChange={handleChange} value={formKit.celular} />
                    <label>Calle y número</label>
                    <input type="text" data-action="formKit|calle" onChange={handleChange} value={formKit.calle} />
                    <label>Código postal</label>
                    <input type="text" data-action="formKit|codigo_postal" onChange={handleChange} value={formKit.codigo_postal} />
                    <label>Ciudad</label>
                    <input type="text" data-action="formKit|ciudad" onChange={handleChange} value={formKit.ciudad} />
                    <label>Colonia</label>
                    <input type="text" data-action="formKit|colonia" onChange={handleChange} value={formKit.colonia} />
                </fieldset>
            )}
        </div>
    );
}

export default Forms;
